import AnimalIcon from '../AnimalIcon';

export default class OverlayCharactersToHide extends Phaser.Group {
  /* eslint-disable max-statements */
  constructor(game, playerIcon, playerNr, characters) {
    super(game);

    //
    this.onEnd = new Phaser.Signal();

    // background
    const bg = this.game.make.image(0, 0, 'bg_location_' + this.game.controller.location);
    this.addChild(bg);

    // icon
    this.icon = new AnimalIcon(this.game, 0, 165, playerNr, playerIcon);
    this.icon.x = this.game.defaultWidth / 2;
    this.addChild(this.icon);

    // characters
    const len = characters.length;
    const dx = 200;
    const x0 = this.game.defaultWidth / 2 - (len - 1) * 0.5 * dx;
    for (let i = 0; i < len; i++) {
      const x = x0 + i * dx;
      const y = 610;
      let char = this.game.make.spine(x, y, characters[i].id, true);
      char.anchor.set(0.5, 1);
      char.setAnimationByName(0, 'idle', true);
      char.setSkinByName('base');
      this.addChild(char);

      char.skeleton.getRootBone().scaleX = -0.4;
      char.skeleton.getRootBone().scaleY = 0.4;

      // mary
      if (characters[i].id === 'twins') {
        char.x += 40;
        char = this.game.make.spine(x - 40, y, 'mary', true);
        char.anchor.set(0.5, 1);
        char.setAnimationByName(0, 'idle', true);
        char.setSkinByName('base');
        this.addChild(char);

        char.skeleton.getRootBone().scaleX = -0.4;
        char.skeleton.getRootBone().scaleY = 0.4;
      }
    }

    this.updateTransform();
    this.update();

    this.playVOs(playerNr, characters);
  }
  /* eslint-enable */

  playVOs(playerNr, characters) {
    const len = characters.length;
    let vos = [];

    if (playerNr === 1) {
      // for player 1
      if (this.game.controller.twoPlayersModel.isReplay) {
        vos = ['ob_05_elinor_023_alt', 'ob_05_elinor_011'];
      } else {
        vos = ['ob_05_elinor_010', 'ob_05_elinor_011'];
      }
    } else {
      // for player 2
      vos = ['ob_05_elinor_011'];
    }
    for (let i = 0; i < len; i++) {
      vos.push('ob_05_elinor_' + characters[i].id);
    }
    this.game.twoPlayersOnboarding.playVOs(vos);
    this.game.twoPlayersOnboarding.onEnd.addOnce(this.handleOnboardingEnd, this);
  }

  handleOnboardingEnd() {
    this.game.time.events.add(500, this.close, this);
  }

  close() {
    this.onEnd.dispatch();
  }
}
